const Fetcher = require('od-modules/utils/fetcher');
var trackingUtils = require('od-modules/utils/tracking.utils');

Odigeo.defineWidget('topdestinations', Odigeo.Widget.extend({

    modelClass: Odigeo.Model.extend({
        defaults: {
            destinationList: [],
            destinationSuggestedList: [],
            departureIata: '',
        },
        getDestinations: function() {
            var topDestinationsFiltered = this.discardDeparture(this.get('destinationList')).slice(0, this.widget.options.sizeList);
            var recentDestinationsFiltered = this.discardDeparture(this.get('destinationSuggestedList'));

            return Odigeo._.uniq(Odigeo._.union(recentDestinationsFiltered, topDestinationsFiltered), 'iata');
        },

        discardDeparture: function(list) {
            return Odigeo._.filter(list, function(iataNode) {
                return iataNode.iata !== this.get('departureIata');
            }, this);
        },
    }),

    viewClass: Odigeo.View.extend({
        templateSettings: Odigeo.Utils.getTmplSettings({variable: ''}),
        events: {
            'tap .top_destination_list .item': 'tapItemTopDestination',
        },
        selectors: {
            topDestinationWrapper: '.top_destination_wrapper',
        },

        toggle: function(show) {
            return this.$cachedSelectors.topDestinationWrapper.toggle(show);
        },

        renderTopDestinations: function(data) {
            var templateDestinations = Odigeo._.template(this.$el.find('.top_destination_list_tmplt').html(), this.templateSettings);
            this.$cachedSelectors.topDestinationWrapper.html(templateDestinations({
                topdestinationsList: data,
            }));
            Odigeo.trigger(this.widget.name + ':isEmpty', {
                id: this.widget.id,
                name: this.widget.name,
                empty: Odigeo._.isEmpty(this.model.get('destinationList')),
            });
        },

        tapItemTopDestination: function(e) {
            var label = 'rec_sel_home_' + ($(e.currentTarget).data('order') + 1);
            e.preventDefault();
            e.stopPropagation();
            Odigeo.trigger(this.widget.name + ':tapItemTopDestination', {
                id: this.widget.id,
                order: this.widget.options.order,
                name: this.widget.name,
                e: e,
            });
            trackingUtils.trackEvent('recommended_destinations', label);
        },
    }),

    init: function() {
        this.listenTo(this.model, 'change:departureIata', this.updateTopDestinations);
        this.options = Odigeo.parseOptions(this.options);
        this.getDestinationsInfo(Odigeo._.bind(this.view.renderTopDestinations, this.view));
    },

    updateTopDestinations: function() {
        var filterNRenderDestinations = Odigeo._.bind(function() {
            this.view.renderTopDestinations(this.model.getDestinations());
        }, this);

        if (!Odigeo._.isEmpty(this.model.get('destinationList'))) {
            filterNRenderDestinations();
        } else {
            this.getDestinationsInfo(filterNRenderDestinations);
        }
    },

    updateTopDestinationsList: function(departureIata) {
        this.model.set('departureIata', departureIata || '');
    },

    getInspirationalRequestUrl: function() {
        return Odigeo.Settings.options.inspirationalServiceUrlFormatter('topDestinations');
    },

    getDestinationsInfo: function(callback) {
        Fetcher.get(this.getInspirationalRequestUrl()).json()
            .then(Odigeo._.bind(function(data) {
                Odigeo._.map(data, function(item) {
                    item.city = item.name;
                    item.cityGeoNodeId = item.id;
                    item.type = 'CITY';
                });
                this.model.set('destinationList', data);

                if (Odigeo._.isFunction(callback)) {
                    callback(this.model.getDestinations());
                }
            }, this));
    },

    toggle: function(params) {
        return this.view.toggle(!params.isMaximum);
    },

    suggestedRecentDestinationsMixed: function(data) {
        this.model.set('destinationSuggestedList', data);
        this.updateTopDestinations();
    },
}));
